import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const ModalHeading = styled.h3`
    padding-bottom: ${Spacing.SM}px;

    font-size: ${FontSizeInPx.LARGE}px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 20px;
    color: ${Colors.Black.V200};
`;
